import { Button, maxWidth } from 'hui';
import React, { useContext } from 'react';
import styled from 'styled-components';
import HeaderContext from '../../HeaderContext';
import { NavLink } from '../../search/style';
import { GA_CATEGORY } from '../constants';
import HeaderList from './header-list';

const CTALinks = styled.div<{ breakPoint: string }>`
  @media (max-width: ${props => props.breakPoint}) {
    display: none;
  }
  ${maxWidth('md')} {
    padding-right: 0;
  }
  display: inline-block;
  padding-right: 8px;
`;

const Actions: React.FC<{}> = () => {
  const { breakPoint, loginData, siteSource, shouldShowActions } = useContext(HeaderContext);
  return (
    <HeaderList>
      <CTALinks breakPoint={breakPoint}>
        {!loginData.logged_in && (
          <NavLink
            href="/login"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked Login`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
            data-label={'header-sign-in'}
            rel="nofollow"
          >
            Sign In
          </NavLink>
        )}
        {shouldShowActions && (
          <Button
            as="a"
            color="tint1"
            small
            ghost
            size="bold"
            href="/tradie/"
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked List Your Business`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
            data-label={'header-list-your-business'}
          >
            List your Business
          </Button>
        )}
      </CTALinks>
    </HeaderList>
  );
};

export default Actions;
